import React, { forwardRef } from "react";
import { FieldTypes } from "utils/formUtils";
import BaseModalForm from "components/BaseModalForm";
import { Form, message, Steps } from "antd";
import moment from "moment";
import ExceptionAPI from "restAPI/ExceptionAPI";
import Vocabulary, { getVocabulary } from "components/Vocabulary";

const ExtendExceptionModal = forwardRef(function ExtendExceptionModal(
  { editId, afterClose, approverList, endDate },
  ref
) {
  const [form] = Form.useForm();
  const { approverlist, step } = approverList;

  const fields = [
    {
      render: () => (
        <div className="m-b-sm"><>You are about to extend this <Vocabulary name="exception" />.</></div>
      ),
    },
    {
      name: "newEndDate",
      label: "New End Date",
      type: FieldTypes.DATE,
      colSpan: 24,
      required: true,
      props: {
        disabledDate: (current) => {
          return (
            current && current.isAfter(moment(endDate).add(1, "years"), "days")
          );
        },
      },
    },
    {
      render: () => {
        return (
          <>
            {approverlist.length > 0 ? (
              <>
                <>This <Vocabulary name="exception" /> extension will then go to:</>
                <Steps
                  className="m-t-sm"
                  direction="vertical"
                  size="small"
                  current={step}
                >
                  {approverlist.map((approver, index) => (
                    <Steps.Step key={index} title={approver.displayName} />
                  ))}
                </Steps>
              </>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    {
      name: "comment",
      label: "Note",
      type: FieldTypes.TEXT_AREA,
      required: true,
    },
  ];

  const onSubmit = async (data) => {
    data.newEndDate = moment(data.newEndDate).utc().format();
    await ExceptionAPI.extendException(editId, data).promise;
    message.success(`Successfully extended the ${getVocabulary("exception")}`);
  };
  return (
    <>
      <BaseModalForm
        modalProps={{ okText: "Submit Extension" }}
        form={form}
        title={<>Extend <Vocabulary name="exception" />?</>}
        onOk={onSubmit}
        ref={ref}
        fields={fields}
        afterClose={afterClose}
      />
    </>
  );
});

export default ExtendExceptionModal;
